<template>
	<rmp-master-account-access-application-base-step v-if="initialized" :title="tc('titles.enterInnYourOrganization')">
		<rmp-text tag="span" type="body-large" :color="colors.grey.darken1">
			{{ tc("common.masterAccountAccessContactInformationStep.stepOne") }}
		</rmp-text>
		<rmp-text-field name="inn"
						:mask="masks.inn"
						:loading="counterpartyLoading"
						data-cy="inn"
						:rules="validation.inn"
						placeholder="7710172832"
						v-model="inn"
						class="mt-4">
		</rmp-text-field>
		<rmp-message-box v-for="({ type }, i) of errors" type="error" :key="i">
			<template v-if="type === MasterAccountAccessErrorTypeEnum.APPLICATION_EXISTS">
				{{ tc("alerts.errors.masterAccountAccessApplicationExists") }}
			</template>
		</rmp-message-box>
		<rmp-text tag="span" type="body-large" :color="colors.grey.darken1">
			{{ $t("common.masterAccountAccessContactInformationStep.subtitleOne") }}
			<a :href="`mailto:${supportEmail}`">{{ supportEmail }}</a>
		</rmp-text>
	</rmp-master-account-access-application-base-step>
</template>

<script setup lang="ts">
import RmpText from "@rmp/core/components/typography/RmpText.vue";
import RmpMessageBox from "@rmp/core/components/common/RmpMessageBox.vue";
import { masks } from "@rmp/core/constants/masks";
import RmpTextField from "@rmp/core/components/fields/RmpTextField.vue";
import { prepareInnRule, requiredRule } from "@rmp/core/utils/validation";
import RmpMasterAccountAccessApplicationBaseStep
	from "@rmp/id/views/masterAccountAccess/steps/RmpMasterAccountAccessApplicationBaseStep.vue";
import { useColors } from "@rmp/core/composables/useColors";
import { useI18n } from "vue-i18n-composable";
import { storeToRefs } from "pinia";
import { usePage } from "@rmp/core/composables/usePage";
import { useMasterAccountAccessSelectCounterpartyStepStore } from "@rmp/id/stores/masterAccountAccess/steps/selectCounterparty";
import { MasterAccountAccessErrorTypeEnum } from "@rmp/id/stores/masterAccountAccess/types/MasterAccountAccessErrorTypeEnum";
import { computed, watch } from "vue";
import BatchService from "@rmp/core/services/batchService";

const { colors } = useColors();

const { tc } = useI18n();

const batchService = new BatchService(({ interval: 1000 }));

const useStore = useMasterAccountAccessSelectCounterpartyStepStore;
const store = useStore();

let {
	inn,
	counterparty,
	counterpartyLoading,
	errors
} = storeToRefs(store);

const {
	fetchCounterparty
} = useStore();

const validation = {
	inn: [requiredRule(), prepareInnRule()]
};

watch(inn, async (value) => {
	if(value && validation.inn.every(v => v(value) === true)) {
		batchService.push(async () => {
			await fetchCounterparty();
		});
	} else if(counterparty.value) {
		counterparty.value = null;
	}
});

const supportEmail = process.env.VUE_APP_SUPPORT_EMAIL;

const { initialized } = usePage({ useStore });
</script>
